export default [
  { 
    path: '/form', 
    name: 'FormList', 
    component: () => import('@/views/form/List'),
    meta: {
      breadcrumbs: [
        { text: 'แบบฟอร์ม', disabled: true }
      ]
    }
  },
  { 
    path: '/form/create', 
    name: 'FormCreate', 
    component: () => import('@/views/form/Form'), 
    meta: { 
      form_type: 'CREATE', 
      form_title: 'สร้าง',
      breadcrumbs: [
        { text: 'แบบฟอร์ม', to: `/form` },
        { text: `สร้างแบบฟอร์ม` },
      ]
    }, 
  },
  { 
    path: '/form/:id/edit', 
    name: 'FormEdit', 
    component: () => import('@/views/form/Form'), 
    meta: { 
      form_type: 'EDIT', 
      form_title: 'แก้ไข',
      breadcrumbs: [
        { text: 'แบบฟอร์ม', to: `/form` },
        { text: `แก้ไขแบบฟอร์ม` },
      ]
    }, 
  }
]